import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useParams } from '../useParams'
import { useBudgetQuery } from '../queries/useBudgetQuery'
import { Currency } from '@/api/contracts/models'

//TODO:
// Przeniosłem currency settings tutaj bo jest używany w Extensions
// robi query przy imporcie Extensions w main.ts.
// To trochę słabe, że Extensions i ten api call są ze sobą powiązane.
// Bo jak robi się import Extensions to robi się też call po settingsy
// nawet jeśli nie użyłem jeszcze żadnego Extensiona.
export const useSettingsStore = defineStore('settings', () => {
  const { budgetId } = useParams()
  const budget = useBudgetQuery(budgetId)

  const locale = computed(() => {
    if (!budget.value?.currency) {
      return 'pl-PL'
    }
    switch (budget.value.currency) {
      case Currency.PLN:
        return 'pl-PL'
      default:
        return 'pl-PL'
    }
  })

  const currency = computed(() => {
    if (!budget.value?.currency) {
      return Currency.PLN
    }
    return budget.value.currency
  })

  return {
    locale,
    currency,
  }
})
